enum FinalidadeEmissao {
    Normal = 1,
    Complementar = 2,
    Ajuste = 3,
    Devolucao = 4,
    NotaCredito = 5,
    NotaDebito = 6,
}

export default FinalidadeEmissao;
